import React, { useEffect, useState } from "react";
import Select from "react-select";
import DDOption from "../../shared/models/DropdownModels";
import axios from "axios";
import { getApiBaseUrl } from "../../utils/apiConfig";

function AddClientCompany({ sendDataToParent,  onLoad}) {
  const [selectedClientCompanyTypeOption, setSelectedClientCompanyTypeOption] = useState([]);
  const [userClientCompanyTypeOptions, setClientCompanyTypeOptions] = useState(new DDOption() || []);
  const [getRMContact1, setRMContact1] = useState('');
  const [getRMContact2, setRMContact2] = useState('');
  const [getRMContact3, setRMContact3] = useState('');
  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if(name === "RMContact1") {
      if (/^\d*$/.test(value)) {
        setRMContact1(value);
      }else {
        return;
      }
    }
    if(name === "RMContact2") {
      if (/^\d*$/.test(value)) {
        setRMContact2(value);
      }else {
        return;
      }
    }
    if(name === "RMContact3") {
      if (/^\d*$/.test(value)) {
        setRMContact3(value);
      }else {
        return;
      }
    }
  }
  function handleClientCompanyTypeChange(e) {
    setSelectedClientCompanyTypeOption(e);
    if (e !== null) {
      sendDataToParent((prevState) => ({
        ...prevState,
        ClientCompanyTypeId: e.value,
      }));
    } else {
      sendDataToParent((prevState) => ({
        ...prevState,
        ClientCompanyTypeId: null,
      }));
    }
  }

  const fetchClientCompanyType = async () => {
    try {
      const response = await axios.get(
        getApiBaseUrl() + "/clientCompanyTypelist"
      );
      if (response.status === 200) {
        setClientCompanyTypeDropdownData(response.data.data[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function setClientCompanyTypeDropdownData(cct) {
    let allModuleOpt = [];
    allModuleOpt = cct.map((p) => ({
      value: p.ClientCompanyTypeId,
      label: p.ClientCompanyTypeName,
      name: p.ClientCompanyTypeName,
      description: "",
      isFixed: false,
      isDisabled: false,
      groupId: null,
    }));
    setClientCompanyTypeOptions(allModuleOpt);
  }

  useEffect(() => {
    fetchClientCompanyType();
    onLoad(undefined);
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="mb-3">
            <label className="form-label">
              Client Company Type<span style={{ color: "red" }}>*</span>
            </label>
            <Select
              name="ModuleId"
              value={
                selectedClientCompanyTypeOption
                  ? selectedClientCompanyTypeOption
                  : []
              }
              isClearable={true}
              options={userClientCompanyTypeOptions || []}
              onChange={(e) => handleClientCompanyTypeChange(e)}
            />
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label">
            Client Company Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="ClientCompanyName"
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6 mb-3">
          <label className="form-label">RMO 1 Name</label>
          <input
            type="text"
            className="form-control"
            name="RMName1"
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Contact</label>
          <input
            type="text"
            className="form-control"
            name="RMContact1"
            onChange={handleChange}
            maxLength="10"
            value={getRMContact1}
          />
        </div>
         <div className="col-md-6 mb-3">
          <label className="form-label">RMO 2 Name</label>
          <input
            type="text"
            className="form-control"
            name="RMName2"
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Contact</label>
          <input
            type="text"
            className="form-control"
            name="RMContact2"
            onChange={handleChange}
            maxLength="10"
            value={getRMContact2}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">RMO 3 Name</label>
          <input
            type="text"
            className="form-control"
            name="RMName3"
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">Contact</label>
          <input
            type="text"
            className="form-control"
            name="RMContact3"
            onChange={handleChange}
            maxLength="10"
            value={getRMContact3}
          />
        </div>

        <div className="col-lg-12 mb-3">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control h-100"
              rows="3"
              name="Description"
              onChange={handleChange}
            />
            <p className="mt-1">Maximum 1000 Characters</p>
          </div>
        </div>

      </div>
     
    </>
  );
}

export default AddClientCompany;
